package uz.ferro.erp

import web.cssom.Color

object Colors {
    val blackHex = "#000000"
    val primaryColorHex = "#2c7b7b"
    val primaryDarkColorHex = "#c7141d"
    val primaryLightColorHex = "#f01620"
    val greenHex: String = "#219653"
    val iconSecondary = "#bbbbbb"
    val iconPrimary = "#555555"
    val gray7dHex = "#7d7d7d"
    val warningIconColorHex = "#f5b041"
    var errorColorHex = "#e30611"
    val accentColor = Color("#2196f3")
    val red = Color("#e74c3c")
    val headerBgColor = Color("#2c7b7b")

    val windowBackground = Color("#f5f7f7")
    val headerStripeColor = Color("#5d53c5")

    val white = Color("#ffffff")
    val black = Color(blackHex)
    val gray01 = Color("#282828")
    val gray02 = Color("#F6F6F6")
    val gray03 = Color("#ededed")
    val gray04 = Color("#f8f8f8")
    val gray05 = Color("#828282")
    val gray06 = Color("#7d7d7d")
    val green = Color(greenHex)
    val orange = Color("#FF5F15")

    val secondaryBackground = Color("#f0fbff")

    val topStripe = black
    val accentContrastColorHex = "#ffffff"
    val accentContrastColor = white
    val footerContrastColor = white

    val backgroundColor = white
    val headerDivider = gray03
    val textPrimary = gray01
    val textSecondary = gray05
    val hoverBackground = gray02
    val footerBackground = gray01
//    val secondaryBackground = gray02

    val borderPrimary = Color("rgba(0, 0, 0, 0.2)")
    val categoryBorder = gray03

    val title = Color("#3d3d3d")

    val label = Color("#777777")

    val divider = Color("#7e7e7e")
    val defaultBorder = Color("#999999")
    val lightBorder = Color("#bbbbbb")
    val errorText = Color("#e30611")

    val loginBgColor = Color("#f2f3f4")
    val adminBgColor = Color("#f5f5f5")
    val adminMenuBgColor = Color("#003e59")
    val adminMenuTextColor = Color("#ffffff")

    val orderStatusNew = Color("#2ECC71")
    val orderStatusAccepted = Color("#F5B041")
    val orderStatusInProgress = Color("#5DADE2")
    val orderStatusInShipping = Color("#5DADE2")
    val orderStatusCompleted = Color("#34495E")
    val orderStatusCanceled = Color("#EC7063")


    val adminItemHover = Color("#f0f0f0")
    val adminItemPressed = Color("#cccccc")
    val selectBorder = Color("#7e7e7e")
    val discountLabelColor = Color("#e30611")
    val productChildrenItemsBg = Color("#fafafa")
    val defaultSelectedColor = Color("#cccccc")

    val productBg = gray04
    val productDesc = gray06

    val amountEnoughLabel = green
    val amountNotEnoughLabel = orange

    val drawerColor = Color("#3d3d3d")
    val drawerContrastColor = Color("#f0f0f0")

    val bg_os_new = Color("#bfc9ca")
    val bg_os_pend = Color("#bfc9ca")
    val bg_os_res_pend = Color("#bfc9ca")
    val bg_os_reserved = Color("#5499c7")
    val bg_os_res_fail = Color("#e74c3c")
    val bg_os_pay_pend = Color("#5499c7")
    val bg_os_pay_success = Color("#a569bd")
    val bg_os_pay_fail = Color("#e74c3c")
    val bg_os_com_pend = Color("#a569bd")
    val bg_os_completed = Color("#58d68d")
    val bg_os_com_fail = Color("#e74c3c")
    val bg_os_rejected = Color("#34495e")
    val bg_os_canceled = Color("#b03a2e")
}